const chatHandler = require('./chat-handler')
const chatContainer = require('./chat-container')

export function start(detail) {

    if (obj[detail.act]) {
        obj[detail.act].start(detail)
    }
}

const obj = {
    load:           { start: (detail) => { chatHandler.load(detail)             } },
    selectUser:     { start: (detail) => { chatHandler.selectUser(detail)       } },
    submit:         { start: (detail) => { chatHandler.submit(detail)           } },
    typing:         { start: (detail) => { chatHandler.typing(detail)           } },
    receiveMessage: { start: (detail) => { chatHandler.receiveMessage(detail)   } },
    quickview:      { start: (detail) => { chatContainer.start(detail)          } },
}